import { FmvStagingComponent } from "@/features/esoPerson/fmvStaging/FmvStagingComponent"

export const FmvStagingPage = () => {
  return <FmvStagingComponent />
}
